import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4dd3451e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "form-wrap" }
const _hoisted_3 = { class: "insured-info" }
const _hoisted_4 = { class: "xag-flex" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "保单号", -1))
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "xag-flex" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "被保险人", -1))
const _hoisted_9 = { class: "value" }
const _hoisted_10 = {
  key: 0,
  class: "form-wrap"
}
const _hoisted_11 = { class: "form-block nongfu-field-placeholder-wrap" }
const _hoisted_12 = { class: "title-wrap" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-notice" }, "* 理赔金额 10000 元以上需要上传", -1))
const _hoisted_14 = { class: "upload-wrap" }
const _hoisted_15 = { class: "form-wrap" }
const _hoisted_16 = { class: "form-block nongfu-field-placeholder-wrap" }
const _hoisted_17 = { class: "title-wrap" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-notice" }, "* 理赔金额 10000 元以上需要上传", -1))
const _hoisted_19 = { class: "upload-wrap" }
const _hoisted_20 = { class: "form-wrap" }
const _hoisted_21 = { class: "form-block nongfu-field-placeholder-wrap" }
const _hoisted_22 = { class: "title-wrap" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-notice" }, "* 理赔金额 10000 元以上需要上传", -1))
const _hoisted_24 = { class: "upload-wrap" }
const _hoisted_25 = { class: "form-wrap" }
const _hoisted_26 = { class: "form-block" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "red-star" }, "被保险人赔款转账授权委托书")
], -1))
const _hoisted_28 = { class: "upload-wrap" }

import { useRoute, useRouter } from 'vue-router'
import { commonErrorHandle } from '@/utils/error-handle'
import { useUploadImage } from '@/compositions/useUpload'
import { useImageGuidTransfer } from '@/compositions/common'
import { Ref, ref, onMounted, reactive, computed } from 'vue'
import { USER_AFTERSALE_REPAIR_CAMERA_AUTH } from '@/config/constant'
import { MalfunctionRepairRepairOrderClaimInfo } from '@/types/malfunction-repair'
import { CommonUploaderFileListItem, CommonCacheGetUploadInfo } from '@/types/public'
import { getRepairOrderDClaimInfo, uploadOrderClaimInfo } from '@/apis/malfunction-repair'
import { clearToast, showToastLoading, showConfirmModal, showToastSuccess } from '@/utils/tools'
import AppHeader from '@/components/Header.vue'
import UploadImage from '@/components/upload/UploadImage.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'repair-order-claim-information',
  setup(__props) {

const $router = useRouter()
const $route = useRoute()
const { checkImageListCanSubmit } = useUploadImage()
const { getImageFullUrl } = useImageGuidTransfer()
const guid = $route.query.guid as string
const amountValue = Number($route.query.amount as string)
const formData: Record<string, CommonUploaderFileListItem[]> = reactive({
  id_card_images: [],
  entrust_images: [],
  legal_images: [],
  business_images: [],
})
const detail: Ref<MalfunctionRepairRepairOrderClaimInfo | null> = ref(null)
const isCompany = computed(() => {
  // 是否为公司
  return detail.value?.client_type === 0
})
const isExceedAmount = computed(() => {
  return amountValue > 10000
})
function format2UploadImageListData(
  guids: string[],
  data: CommonCacheGetUploadInfo
): CommonUploaderFileListItem[] {
  return guids.map((guid) => ({
    url: data[guid].url,
    content: '',
    status: 'done',
    response: {
      guid,
      url: data[guid].url,
    },
  }))
}
function judgeShowConfirmModal() {
  if (isCompany.value) {
    // 企业类型的时候
    return (
      formData.entrust_images.length > 0 ||
      formData.legal_images.length > 0 ||
      formData.business_images.length > 0
    )
  } else {
    return formData.id_card_images.length > 0 || formData.entrust_images.length > 0
  }
}
async function initData() {
  showToastLoading()
  try {
    let data = await getRepairOrderDClaimInfo(guid)
    const guids = [
      ...(data.id_card_images || []),
      ...(data.entrust_images || []),
      ...(data.legal_images || []),
      ...(data.business_images || []),
    ].filter((value) => value)
    const imageData = await getImageFullUrl(guids)
    formData.id_card_images = format2UploadImageListData(data.id_card_images, imageData)
    formData.entrust_images = format2UploadImageListData(data.entrust_images, imageData)
    formData.legal_images = format2UploadImageListData(data.legal_images, imageData)
    formData.business_images = format2UploadImageListData(data.business_images, imageData)
    detail.value = data
    clearToast()
    if (data.is_copy_images) {
      await showConfirmModal({
        title: '提示',
        message:
          '系统检测到当前保单的被保人与历史保单一致，已自动为您获取上一份保单的理赔资料。如确认无误可以直接提交并确认使用，如需更新可以在本页面进行编辑和重新上传！',
        className: 'nongfu-dialog-confirm-class',
        showCancelButton: false,
        confirmButtonText: '知道了',
      })
    }
  } catch (error) {
    commonErrorHandle(error)
  }
}

function imageListChange(key: string, data: CommonUploaderFileListItem[]) {
  formData[key] = data
}

const canSubmit = computed(() => {
  // 是否可以提交
  let bool = checkImageListCanSubmit(formData.entrust_images)
  if (isExceedAmount.value && bool) {
    // 个人时校验身份证图片
    if (isCompany.value) {
      bool =
        checkImageListCanSubmit(formData.legal_images) &&
        checkImageListCanSubmit(formData.business_images)
    } else {
      bool = checkImageListCanSubmit(formData.id_card_images)
    }
  }
  return bool
})
async function confirmSubmit() {
  try {
    await showConfirmModal({
      title: '',
      message: '确认提交?',
      className: 'repair-dialog',
    })
  } catch (error) {
    console.log('error', error)
    return
  }
  try {
    showToastLoading()
    await uploadOrderClaimInfo({
      guid,
      id_card_images: formData.id_card_images.map((item) => item?.response?.guid),
      entrust_images: formData.entrust_images.map((item) => item?.response?.guid),
      legal_images: formData.legal_images.map((item) => item?.response?.guid),
      business_images: formData.business_images.map((item) => item?.response?.guid),
    })
    showToastSuccess('提交成功')
    setTimeout(() => {
      $router.go(-1)
    }, 1500)
  } catch (error) {
    commonErrorHandle(error)
  }
}
onMounted(() => {
  initData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "理赔资料上传" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString(detail.value?.policy_no), 1)
          ]),
          _createElementVNode("li", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, _toDisplayString(detail.value?.user_name) + "（" + _toDisplayString(_unref(isCompany) ? '企业' : '个人') + "）", 1)
          ])
        ])
      ]),
      (!_unref(isCompany))
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", {
                  class: _normalizeClass(_unref(isExceedAmount) ? 'red-star' : '')
                }, "被保险人身份证正反面照片", 2)
              ]),
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                (detail.value)
                  ? (_openBlock(), _createBlock(UploadImage, {
                      key: 0,
                      cameraAuthKey: _unref(USER_AFTERSALE_REPAIR_CAMERA_AUTH),
                      onChange: _cache[0] || (_cache[0] = (data) => imageListChange('id_card_images', data)),
                      defaultList: formData.id_card_images
                    }, null, 8, ["cameraAuthKey", "defaultList"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(isCompany))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("span", {
                    class: _normalizeClass(_unref(isExceedAmount) ? 'red-star' : '')
                  }, "法人身份证正反面照片", 2)
                ]),
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  (detail.value)
                    ? (_openBlock(), _createBlock(UploadImage, {
                        key: 0,
                        cameraAuthKey: _unref(USER_AFTERSALE_REPAIR_CAMERA_AUTH),
                        onChange: _cache[1] || (_cache[1] = (data) => imageListChange('legal_images', data)),
                        defaultList: formData.legal_images
                      }, null, 8, ["cameraAuthKey", "defaultList"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("span", {
                    class: _normalizeClass(_unref(isExceedAmount) ? 'red-star' : '')
                  }, "被保险人营业执照照片", 2)
                ]),
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  (detail.value)
                    ? (_openBlock(), _createBlock(UploadImage, {
                        key: 0,
                        cameraAuthKey: _unref(USER_AFTERSALE_REPAIR_CAMERA_AUTH),
                        onChange: _cache[2] || (_cache[2] = (data) => imageListChange('business_images', data)),
                        defaultList: formData.business_images
                      }, null, 8, ["cameraAuthKey", "defaultList"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            (detail.value)
              ? (_openBlock(), _createBlock(UploadImage, {
                  key: 0,
                  cameraAuthKey: _unref(USER_AFTERSALE_REPAIR_CAMERA_AUTH),
                  onChange: _cache[3] || (_cache[3] = (data) => imageListChange('entrust_images', data)),
                  defaultList: formData.entrust_images
                }, null, 8, ["cameraAuthKey", "defaultList"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(CommonFooterNextButton, {
      title: "提交",
      disabled: !_unref(canSubmit),
      onClick: confirmSubmit
    }, null, 8, ["disabled"])
  ], 64))
}
}

})